import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import { CashRegisterPaymentType } from './cash-register-payment-type.enum';
import { Big } from 'big.js';

@MappedClass()
export class CashRegisterPayment {
  @MappedPropertyCurrency()
  amount: Big | null;

  @MappedProperty()
  description: string | null;

  @MappedProperty()
  type: CashRegisterPaymentType;
}
